import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['submit'];

  connect() {
    this.toggleSubmit();
    this.element.addEventListener('change', this.toggleSubmit);
  }

  disconnect() {
    this.element.removeEventListener('change', this.toggleSubmit);
  }

  toggleSubmit = () => {
    const requiredFileInputs = this.fileInputs();

    const allFilled = requiredFileInputs.every(input => input.files && input.files.length > 0);

    this.submitTarget.disabled = !allFilled;
  };

  fileInputs() {
    return Array.from(
      this.element.querySelectorAll(
        'input[type=\'file\']:not([disabled]):not([hidden])'
      )
    ).filter(input => input.offsetParent !== null);
  }
}
